import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["box", "hidden", "submit"]

  connect() {
    this.syncFromBoxes()
  }

  onInput(event) {
    const box = event.currentTarget
    box.value = box.value.replace(/\D/g, "").slice(0, 1)

    if (box.value) {
      const next = this.nextBox(box)
      if (next) next.focus()
    }

    this.syncFromBoxes()
  }

  onKeydown(event) {
    const box = event.currentTarget

    if (event.key === "Backspace" && !box.value) {
      const prev = this.prevBox(box)
      if (prev) {
        prev.value = ""
        prev.focus()
        this.syncFromBoxes()
        event.preventDefault()
      }
    } else if (event.key === "ArrowLeft") {
      const prev = this.prevBox(box)
      if (prev) {
        prev.focus()
        event.preventDefault()
      }
    } else if (event.key === "ArrowRight") {
      const next = this.nextBox(box)
      if (next) {
        next.focus()
        event.preventDefault()
      }
    }
  }

  onPaste(event) {
    event.preventDefault()
    const text = (event.clipboardData || window.clipboardData).getData("text") || ""
    const digits = text.replace(/\D/g, "").slice(0, this.boxTargets.length)

    this.boxTargets.forEach((box, i) => {
      box.value = digits[i] || ""
    })

    const focusIndex = Math.min(digits.length, this.boxTargets.length - 1)
    if (this.boxTargets[focusIndex]) this.boxTargets[focusIndex].focus()

    this.syncFromBoxes()
  }

  syncFromBoxes() {
    const code = this.boxTargets.map((b) => b.value || "").join("")
    this.hiddenTarget.value = code
    this.updateSubmit(code)
  }

  updateSubmit(code) {
    if (!this.hasSubmitTarget) return
    if (code.length === this.boxTargets.length) {
      this.submitTarget.removeAttribute("disabled")
    } else {
      this.submitTarget.setAttribute("disabled", "disabled")
    }
  }

  nextBox(box) {
    const index = this.boxTargets.indexOf(box)
    return this.boxTargets[index + 1]
  }

  prevBox(box) {
    const index = this.boxTargets.indexOf(box)
    return this.boxTargets[index - 1]
  }
}
